// @flow
import { selectSetupOwner } from 'src/Cart/Setup/modules/selectors';

import type { FullState, SMD } from '../../types';
import type { ServicePrice } from '../../types/price';

import { smdResource } from './actions';

export const selectPrices = (state: FullState): Array<ServicePrice> =>
  state.tmch.prices;

export const selectJurisdictions = (
  state: FullState,
): Array<{ text: string, value: string }> => state.tmch.jurisdictions;

export const selectSmd = (state: FullState): Array<SMD> =>
  state.tmch.smd[selectSetupOwner(state)] || [];

export const selectShouldFetchSmd = (state: FullState): any =>
  smdResource.selectShouldFetch(state, selectSetupOwner(state));

export const selectIsFetchingSmd = (state: FullState): any =>
  smdResource.selectIsFetching(state, selectSetupOwner(state));
